// extracted by mini-css-extract-plugin
export default {"modal":"HD-z","addItemButton":"ID-z","plusCircle":"JD-z","branchVisible":"KD-z"};